import { DashboardSummary } from '@/components/dashboard/DashboardSummary'

export default function DashboardPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="mx-auto w-full max-w-[1600px] space-y-10 px-4 py-8 sm:px-6 lg:px-10">
        

        <DashboardSummary />

                
      </div>
    </div>
  )
}








